/**
 * Resolve a GqlError into a localized, user-facing message.
 *
 * The backend deprecated `GqlError.message` — it has no resolver and ALWAYS
 * returns null; the documented contract is "the client generates the message
 * from `code`". INSi error codes are surfaced as i18n keys named exactly after
 * the code (e.g. `insi_feature_disabled_on_workspace` in the translation
 * files), so we translate `code` directly. When no matching i18n key exists we
 * fall back to the backend-supplied `description` (English), then to a
 * caller-provided generic message.
 *
 * Reading `error.message` (the previous behaviour) silently produced an empty
 * snackbar on every INSi error — this is the single helper every INSi mutation
 * consumer should use instead.
 *
 * @param {{code?: string, description?: string, message?: string}|null|undefined} error
 * @param {(key: string, opts?: object) => string} t - i18next translator
 * @param {string} [fallback] - shown when the error carries no usable text
 * @returns {string|undefined}
 */
export const resolveInsiError = (error, t, fallback) => {
  if (!error) return fallback;
  const base = error.description || fallback;
  // `code` is non-null on a GqlError; translate it, defaulting to the backend
  // description / caller fallback when there is no i18n key for that code.
  return error.code ? t(error.code, { defaultValue: base }) : base;
};

export default resolveInsiError;
